import React from 'react';

import { DateFormatPatterns } from '@clearverify/constants';
import { numberWithCommas } from '@clearverify/utils';

import { useDashboardCVAdminData } from 'src/hooks/dashboard';

import { DashboardOverviewBlockListItem } from './DashboardOverviewBlockListItem';

type DashboardOverviewBlockRevenueShareAccountsProps = {
  revenueShareAccounts: number;
  loading: boolean;
};

export const DashboardOverviewBlockRevenueShareAccounts: React.FC<
  DashboardOverviewBlockRevenueShareAccountsProps
> = ({ revenueShareAccounts, loading }) => {
  const { date } = useDashboardCVAdminData();

  return (
    <DashboardOverviewBlockListItem
      loading={loading}
      number={numberWithCommas(revenueShareAccounts)}
      title="Accounts with Rev. Share"
      subtitle={`Current as of: ${date.toFormat(DateFormatPatterns.shortDateWithSlash)}`}
    />
  );
};
